<template>
  <svg
    width="241"
    height="252"
    viewBox="0 0 241 252"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby="icon-session-expired-title"
  >
    <title id="icon-session-expired-title">Session expired</title>
    <ellipse cx="120.5" cy="240.5" rx="100" ry="11.5" fill="#E4E4E4" />
    <rect width="241" height="241" rx="120.5" fill="#F6F6F6" />
    <rect x="20.5" y="21" width="200" height="200" rx="100" fill="#DEE2E4" />
    <path
      d="M175 110V154H164V110H175ZM164 165V176H175V165H164ZM153 150.095C144.915 159.225 133.145 165 120 165C95.745 165 76 145.255 76 121C76 96.745 95.745 77 120 77V126.5L161.525 84.975C151.46 73.37 136.61 66 120 66C89.64 66 65 90.64 65 121C65 151.36 89.64 176 120 176C132.375 176 143.815 171.93 153 165V150.095Z"
      fill="#A6A6A6"
    />
  </svg>
</template>
